import AppRoute from 'src/router/app-route';
import { Route } from 'src/router/routes';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useSiteContext() {
    const $route = useRoute();

    const employerRouteNames = [
        // Primary employer routes
        Route.EmployerLandingPage,
        Route.PricingPage,

        // Job manager routes
        Route.JobManagerPage,
        Route.JobManagerListPage,
        Route.JobManagerListingPage,
        Route.JobManagerWizardPage,
        Route.JobManagerApplicationPage,
        Route.JobManagerApplicationsListPage,
        Route.JobManagerAnalyticsPage,
        Route.JobManagerPreviewPage,

        // Company routes
        Route.CompanyManagerPage
    ];

    const isEmployerSite = computed(() => {
        if (employerRouteNames.includes($route.name)) {
            return true;
        }
        const isEmployerParentRoute = $route.matched?.some(record => {
            return record.name && employerRouteNames.includes(record.name);
        });
        if (isEmployerParentRoute) {
            return true;
        }
        if ($route.meta?.employerSite) {
            return true;
        }
        return false;
    });

    const siteSwitcherText = computed(() => {
        return isEmployerSite.value
            ? 'Go to Job Seekers Site'
            : 'Go to Employers Site';
    });

    const siteSwitcherRoute = computed(() => {
        return isEmployerSite.value
            ? AppRoute.build(Route.LandingPage)
            : AppRoute.build(Route.EmployerLandingPage);
    });

    return {
        isEmployerSite,
        siteSwitcherText,
        siteSwitcherRoute
    };
}
